import { datadogRum } from '@datadog/browser-rum'
import pkg from '../../package.json'
import fetch from 'node-fetch'

interface UserInfo {
	tracking: boolean
}

const org = localStorage.getItem('arc.organization')

const init = async (): Promise<void> => {
	let response = (await fetch('/user.json', {
		method: 'GET',
	})) as unknown as Response
	let data = (await response.json()) as UserInfo

	if (process.env.NODE_ENV !== 'development' && data.tracking) {
		await new Promise((resolve) => setTimeout(resolve, 1000)) // wait for assets to load
		if (data.tracking) {
			console.info('Initializing Datadog Rum')
			// user has accepted third-party tracking. Do not use RUM without this!
			datadogRum.init({
				applicationId: 'f7f13641-15e2-4ef1-b195-ba7bcf202780',
				clientToken: 'pub8b308b19c7b3ca4be54559fe5e2b481f',
				site: 'datadoghq.com',
				service: 'dev-center-ui',
				env: localStorage.getItem('arc.environment'),
				version: `Dev Center UI - ${pkg.version}`,
				sessionSampleRate: 100,
				sessionReplaySampleRate: 100,
				trackUserInteractions: true,
				trackResources: true,
				trackLongTasks: true,
				defaultPrivacyLevel: 'mask-user-input',
				actionNameAttribute: 'data-testid',
				allowedTracingUrls: [
					// connect RUM to APM for full-stack tracing
					`https://${org}.arcpublishing.com`,
					`https://sandbox.${org}.arcpublishing.com`,
				],
			})

			datadogRum.setGlobalContextProperty('arc-organization', org)

			let userId = localStorage.getItem('arc.userId')

			if (typeof userId === 'string') {
				datadogRum.setUser({
					id: userId,
					name: localStorage.getItem('arc.displayName') ?? undefined,
					email: localStorage.getItem('arc.email') ?? undefined,
				})
			}
		}
	}
}

init().catch((e) => {
	console.error('Error initializing Datadog RUM:', e)
})
